module.exports = "/img/_/_/_/assets/images/creeper/book/common//26.jpg?fb7843df1bc723a71dc1d3b8fa1c8685";